import React, { FunctionComponent, memo } from "react";
import { components } from "react-select";
import { MultiValueRemoveProps } from "react-select/src/components/MultiValue";

import { Icon } from "../../../../../Icon";

const iconSizes: { [index: string]: string } = {
  sm: "xs",
  md: "sm",
  lg: "sm",
};

export const MultiValueRemove: FunctionComponent<MultiValueRemoveProps<any>> = memo(props => {
  const size = props.selectProps.size;
  return (
    <components.MultiValueRemove {...props}>
      <Icon icon="close" size={iconSizes[size]} />
    </components.MultiValueRemove>
  );
});
